export const CHANGE_BONDED_STATE = "CHANGE_BONDED_STATE";
export const CHANGE_DEPOSIT_STATE = "CHANGE_DEPOSIT_STATE";
export const CHANGE_GOVERNANCE_STATE = "CHANGE_GOVERNANCE_STATE";
export const CHANGE_STABLE_STATE = "CHANGE_STABLE_STATE";
export const CHANGE_FUND_STATE = "CHANGE_FUND_STATE";
export const CHANGE_DE_STATE = "CHANGE_DE_STATE";